import { addons } from '@storybook/manager-api';
import { create } from '@storybook/theming';

addons.setConfig({
    sidebar: {
        showRoots: true,
    },
    theme: create({
        base: "dark",
        brandTitle: 'Airzone',
        brandUrl: 'https://design.airzonecloud.com/',
        brandImage: 'https://res.cloudinary.com/airzone/image/upload/v1707306077/images/airzone.svg',
        brandTarget: '_self',
        
        // Typography
        fontBase: '"Montserrat", sans-serif',
        fontCode: 'monospace',

        // Color
        colorPrimary: '#3B4E52',
        colorSecondary: '#3B4E52',

        // UI
        appBg: '#f5f5f5',
        appContentBg: '#cccccc',
        //appPreviewBg: '#e5e5e5',
        appBorderColor: '#585C6D',
        appBorderRadius: 4,

        // Text colors
        textColor: '#3B4E52',
        textInverseColor: '#F8F7F7',

        // Toolbar default and active colors
        barTextColor: '#9E9E9E',
        barSelectedColor: '#585C6D',
        //barHoverColor: '#585C6D',
        barBg: '#f5f5f5',

        // Form colors
        inputBg: '#F8F7F7',
        inputBorder: '#3B4E52',
        inputTextColor: '#3B4E52',
        inputBorderRadius: 2,
    }), 
});